$( document ).ready(function() {
	$( "#search_solicitud" ).keyup(function() {
	  search_necesidad()
	});

	$( "#search_centro" ).keyup(function() {

	  	search_centro()
    });
    let hideAlert;
    function delayAlert() {
        hideAlert = window.setTimeout(function() {
            $('#carritoAlert').removeClass('active');
        }, 1500);
    }

    function countDonativos() {
        let total = $('.donativo-item').length,
            $btn = $('.btn-donacion');

        $btn.attr('data-counter', total);

        if(!total > 0) {
            $btn.addClass('zero');
        } else {
            $btn.removeClass('zero');
        }
    }

    countDonativos();

	$(document).on('click', '.btn-agregar', function(){
		$.ajax({
	      	url: base_url+"/donacion/agregar_donacion/"+this.id+'/1',
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		//agregar elemento a la tercera columna
                $("#box_carrito").html(result)

                if($('#carritoAlert').hasClass('active')) {
                    window.clearTimeout(hideAlert);
                    hideAlert = window.setTimeout(function() {
                        $('#carritoAlert').removeClass('active');
                    }, 1500);
                } else {
                    $('#carritoAlert').addClass('active');
                    delayAlert();
                }

                countDonativos();
	    	}}
	    );
	})

	$(document).on('click', '.btn-eliminar-carrito', function(){
		$.ajax({
	      	url: base_url+"/donacion/eliminar_elemento_carrito/"+this.id+'/1',
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		//agregar elemento a la tercera columna
                $("#box_carrito").html(result);
                countDonativos();
	    	}}
	    );
	})

	$(".check_categoria").on('click',function () {
		var ids=''
		var id_centro=$("#id_centro").val()
		var search=$("#search_solicitud").val().trim()

		if (search!='') {
			search = search.replace("/", "");
		}
		$(".check_categoria").each(function() {
		    if( $("#"+this.id).is(':checked') ) {
			    var id = this.id.split('_')
			    ids += id[1]+'_'
			}
		});

		if (ids=='') {
			ids ='_'
		}

		$.ajax({
	      	url: base_url+"/donacion/filtrar_search/1/"+ids+'/'+id_centro+'/'+search,
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		//agregar elemento a la tercera columna
	      		$("#box_necesidades").html(result)
	    	}}
	    );

	})
	$(".btn_filtro_centro").on('click',function(){
		$(".btn_filtro_centro").removeClass('active')
		$("#"+this.id).addClass('active')
		var ids=''
		var id_centro_valor=this.id.split('_')
	    $("#id_centro").val(id_centro_valor[0])
	    var search=$("#search_solicitud").val().trim()

		if (search!='') {
			search = search.replace("/", "");
		}

		$(".check_categoria").each(function() {
		    if( $("#"+this.id).is(':checked') ) {
			    var id = this.id.split('_')
			    ids += id[1]+'_'
			}
		});

		if (ids=='') {
			ids ='_'
		}
		$.ajax({
	      	url: base_url+"/donacion/filtrar_search/1/"+ids+"/"+this.id+'/'+search,
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		//agregar elemento a la tercera columna

	      		$("#box_necesidades").html(result)

	    	}}
        );

        let name = $(this).children('.nombre-ca').text(),
            target = $('#currentCentro');

        if(name == 'Todos') {
            name = 'Todos los centros de acopio';
        }

        target.text(name);

	})

	$(".search_necesidad_button").on('click',function(){
		search_necesidad()
	})

	$("#search_centro_button").on('click',function(){
		search_centro()
	})

    document.getElementById("search_centro").addEventListener("search", search_centro);
});

function search_necesidad() {
	var ids=''
	var id_centro=$("#id_centro").val()

	var search=$("#search_solicitud").val().trim()

		search = search.replace("/", "");
		$(".check_categoria").each(function() {
		    if( $("#"+this.id).is(':checked') ) {
			    var id = this.id.split('_')
			    ids += id[1]+'_'
			}
		});

		if (ids=='') {
			ids ='_'
		}


	if (search!='') {
		var url_search=base_url+"/donacion/filtrar_search/1/"+ids+"/"+id_centro+'/'+search
	}else{
		var url_search=base_url+"/donacion/filtrar_search/1/"+ids+"/"+id_centro

	}
		$.ajax({
	      	url: url_search,
	      	method: 'get',
	      	data: '',
	      	success: function(result){
	      		//agregar elemento a la tercera columna

	      		$("#box_necesidades").html(result)

	    	}}
	    );

}

function search_centro() {
	var id_centro=$("#id_centro").val()

	var search=$("#search_centro").val().trim()

	$.ajax({
      	url: base_url+"/donacion/search_centro/1/"+id_centro+'/'+search,
      	method: 'get',
      	data: '',
      	success: function(result){
      		//agregar elemento a la tercera columna

      		$("#box_centros").html(result)

    	}}
    );
}
